import _ from 'lodash';
import moment, { parseTwoDigitYear } from 'moment';
import numeral from 'numeral';

import api from './api';
import { Download } from './core/download';
import infoBoard from './core/infoboard';
import map from './core/map';
import compare from './core/map/compare';
import { pinBuilder } from './core/map/pinBuilder';
import search from './core/search';
import selection from './core/selection';
import sidebar from './core/sidebar';
import googleAnalytics from './core/tools/googleanalytics';
import tour from './core/tour';
import environment from './environment';
import layers from './layers';
import { notify, NOTIFY_TYPE } from './shared/notify';
import { enableVehicleType } from './core/vehicleType';
import { FeaturePermission } from '../constants/feature.permission.helper';
import { VehicleTypeEnum } from './core/vehicleType/constants';
import i18n, { translate } from './core/tools/translate';
import Workspace from './workspaces';
import { Constants } from '../constants/constants';
import { ContextEnum } from '../enuns/context.enum';

const LayerControls = (name) => require('./controls').get(name);
const LayerInfo = (name) => require('./info').get(name);
const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

const bootstrap = (() => {
    const _enableSidebar = async (value) => {
        const options = {
            title: `<img src="${environment.get('IMAGES_HOST')}/gig_logo_line.png">`,
            entries: {}
        };

        if (value) {
            _.forEach(environment.get('FEATURES'), (isEnable, feature) => {
                if (!isEnable) return;

                LayerControls(feature).init();

                options.entries[feature] = LayerControls(feature).get();
            });

            setTimeout(() => {
                sidebar.setControls((map.getCurrent() || {})._id);

                // O check "limitar a area pesquisada" nasce desabilitado, porque no carregamento
                // nao existe area no mapa. Depende do setControls acima, que cria o registro
                // do sidebar que os controls leem.
                _.forEach(['NetworkAfterSales', 'CompetitorsAfterSales'], feature => {
                    if (environment.get('FEATURES')[feature]) {
                        LayerControls(feature).refreshSearchedAreaFilter();
                    }
                });
            }, 700);
        }

        await sidebar.init(document.getElementById('trigger-sidebar'), options);
    };

    const _enableInfoboard = () => {
        $('#trigger-infoboard').show();
        infoBoard.setOptions(document.getElementById('infoboard-content'), { trigger: '#trigger-infoboard' });

        _.forEach(environment.get('FEATURES'), (isEnable, feature) => {
            if (!isEnable) return;

            switch (feature) {
                case 'Competitors':
                case 'Dealerships':
                case 'StoresMotocycle':
                case 'StoresConsortium':
                case 'StoreInactive':
                    LayerInfo('Stores').init();
                    LayerInfo('Stores').create(null, feature);
                    // LayerInfo('Compare').create(false)
                    break;

                case 'NetworkAfterSales':
                    LayerInfo('StoresInfoAfterSales').init();
                    LayerInfo('StoresInfoAfterSales').create(null, feature);
                    break;

                case 'ServiceArea':
                    LayerInfo('Summary').init();
                    LayerInfo('Summary').create({ visible: true });
                    break;

                default:
                    if (LayerInfo(feature)) {
                        LayerInfo(feature).init();
                        LayerInfo(feature).create({ visible: true });
                    }
            }
        });
    };

    const _enableLogin = (value) => {
        require('./login');
        const $leftPane = $('#left-pane');
        const $middleContent = $('.middle-content');

        if (value) {
            let fTypes = [];
            _.forEach(VehicleTypeEnum, function (v, k) { fTypes.push({ name: k, value: v }); });
            const vehicleTypeName = _.filter(fTypes, ['value', environment.get('CONFIG.USERVEHICLETYPE')])[0].name;
            const getLogoPath = (suffix) => {
                suffix = suffix || '';
                const basePath = environment.get('IMAGES_HOST');
                return environment.get('CONFIG.USERVEHICLETYPE') === VehicleTypeEnum.Moto
                    ? `${basePath}/motos/logo_${environment.get('CONFIG.CLIENT').toUnderscoreCase()}${suffix}.png`
                    : `${basePath}/logo_${environment.get('CONFIG.CLIENT').toUnderscoreCase()}${suffix}.png`;
            };

            const isAfterSales = environment.get('CONFIG.IS_AFTER_SALES');

            if (!isAfterSales) {
                $leftPane.find('.bottom-content').find('.flag-settings').html(`
                    <div class="logo-image" title="Logo">
                        <a id="client-selection-link" data-target="#" title="${environment.get('CONFIG.CLIENT')}">
                            <img class="img-circle" style="width: 42px; height: 42px;" src="${getLogoPath()}">
                            <span class="flag-name">${environment.get('CONFIG.CLIENT')}<span class="flag-type">${translate('Common.VehicleType.' + vehicleTypeName)}</span></span>
                            <div><i class="fa fa-sort"></i></div>
                        </a>
                    </div>
                `);
            } else {
                $leftPane.find('.bottom-content').find('.flag-settings').html(`
                    <div class="logo-image" title="Logo">
                        <a id="client-selection-link" data-target="#" title="${environment.get('CONFIG.CLIENT')}">
                            <img style="transform: scale(0.8); margin: auto;" src="${getLogoPath('_normal')}">
                            <div><i class="fa fa-sort" style="margin: 0"></i></div>
                        </a>
                    </div>
                `);
            }

            $leftPane.find('#user-info').prepend('<i class="fa fa-user-circle"></i>' + sessionStorage.username);

            const $selectCurrentClient = $('#client-selection-container');

            $selectCurrentClient.empty();
            let $template = '';
            let _brands = environment.get('CONFIG.AUTHORIZEDBRANDS');
            // console.log('_brands', _brands);
            $template = `<div class="client_selection_wrapper">`;
            _(_brands).uniqBy('idVehicleType').forEach(brandByType => {
                $template += `<div class="client_selection--tab data-veic-type_${brandByType.idVehicleType}${brandByType.idVehicleType == 1 ? ' active' : ''}">`;
                _(_brands).filter(['idVehicleType', brandByType.idVehicleType]).forEach(brand => {
                    $template += `<a data-target="#" data-id="${brand.id}" title="${brand.name}">
                                        <img class="img-circle" style="width: 42px; height: 42px;" src="${environment.get('IMAGES_HOST')}${brandByType.idVehicleType === 3 ? '/motos' : ''}/logo_${brand.name.toUnderscoreCase()}.png">
                                    </a>`;
                });
                $template += `</div>`;
            });
            $template += `  <div class="client_selection--tab_selector">
                                <div data-veic-type="1" class="active"><i class="fa fa-car"></i></div>
                                <div data-veic-type="2"><i class="fa fa-truck"></i></div>
                                <div data-veic-type="3"><i class="fa fa-motorcycle"></i></div>
                            </div>
                        </div>`;
            $selectCurrentClient.append($template);

            const activateTab = typeId => {
                const tab = $(`.client_selection--tab.data-veic-type_${typeId}`);
                const tab_selector = $(`.client_selection--tab_selector div[data-veic-type='${typeId}']`);
                $(`.client_selection--tab`).removeClass(`active`);
                $(`.client_selection--tab_selector div`).removeClass(`active`);
                tab.addClass(`active`);
                tab_selector.addClass(`active`);
            };

            $selectCurrentClient.find('.client_selection--tab_selector > div').on('click', function () {
                let id = $(this).attr('data-veic-type');
                activateTab(id);
            });

            $selectCurrentClient.find('a').on('click', function () {
                $selectCurrentClient.slideToggle();
                $middleContent.find('.backdrop').fadeToggle();
                let id = $(this).data('id');
                const vehicleTypeId = $('.client_selection--tab_selector div.active').attr('data-veic-type');
                api.management.update.client.user({ clientId: id, vehicleTypeId: vehicleTypeId });
            });

            $('#client-selection-link').on('click', () => {
                $selectCurrentClient.slideToggle();
                $middleContent.find('.backdrop').fadeToggle();
            });

            $middleContent.find('.backdrop').click(() => {
                $selectCurrentClient.slideToggle();
                $middleContent.find('.backdrop').fadeToggle();
            });

            $leftPane.find('.bottom-content').show();
            $leftPane.find('.login-container').hide();
            $('#change-password-container').hide();

            setTimeout(() => {
                $('#sidebar-container').fadeIn(700);
                $('#map-blur').fadeOut(700);
            }, 700);

            if (!isAuthorized(FeaturePermission.SYSTEM.showControlPanel)) {
                $('#control-panel').hide();
            }

            if (!isAuthorized(FeaturePermission.SYSTEM.manual)) {
                $('#manual').hide();
                $('#trigger-manual').hide();
            }

        } else {
            $('#map-blur').fadeIn(1000);
            $leftPane.find('.bottom-content').hide();
            $leftPane.find('.login-container').fadeIn(700);
            $('#sidebar-container').hide();
        }
    };

    const _enableTour = () => tour.init();

    const _enableManual = () => {
        $('#trigger-manual').show().on('click', () => {
            api.general.log.action(ContextEnum.PanelSuperior, 'Abrir Manual');
            googleAnalytics.trackEventGA('HelpPage', 'Open');
        });
    };

    const _enableVehicleType = () => {
        enableVehicleType();
    };

    const _enableCompare = () => {
        $('#trigger-compare').show().on('click', (e) => {
            api.general.log.action(ContextEnum.PanelSuperior, 'Comparar Mapas');
            e.preventDefault();
            compare.toggle();
        });
    };

    const _enableLayerIndicator = () => {
        $('.layer-indicator').show().on('click', (e) => {
            e.preventDefault();
            map.get().next();
        });
    };

    const _enableMap = () => {
        map.create(document.getElementById('map-container'));
        pinBuilder.preload();
    };

    const _enableSearch = () => {
        search();
    };

    const _enableManagement = () => {
        $('#control-panel').on('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            window.open(Constants.CONTROL_PANEL_URL);
        });
    };

    const _enableSelection = () => {
        if (isAuthorized(FeaturePermission.MAP.toolSelectShape)) {
            selection.getInstance().init();
        }
    };

    const _enableDownload = () => {
        if (isAuthorized('stores-retention-layer')) {
            const download = new Download();
            $('#trigger-download').show().on('click', (e) => {
                e.preventDefault();
                download.create();
            });
        }
    };

    const _enableAnalytics = () => googleAnalytics.initTracking();

    const _configPlugins = () => {
        require('numeral/locales.js');
        numeral.locale('pt-br');
        require('moment/locale/pt-br.js');
        moment.locale('pt-br');

        if (i18n.language().indexOf('pt') > -1) {
            require('@progress/kendo-ui/js/messages/kendo.messages.pt-PT');
            require('@progress/kendo-ui/js/cultures/kendo.culture.pt-BR');
            kendo.culture('pt-BR');
        } else {
            require('@progress/kendo-ui/js/messages/kendo.messages.en-US');
            require('@progress/kendo-ui/js/cultures/kendo.culture.en-US');
            kendo.culture('en-US');
        }

        $.protip();
    };

    const doLogin = authentication =>
        $(document).ready(() => {
            if (authentication) {
                notify(NOTIFY_TYPE.SUCCESS, 'Usuário autenticado.');
                _configPlugins();
                _enableMap();
                _enableSearch();
                _enableInfoboard();
                _enableDownload();
                _enableManual();
                _enableVehicleType();
                _enableSidebar(true);
                _enableLogin(true);
                _enableAnalytics();
                _enableCompare();
                _enableLayerIndicator();
                _enableManagement();
                _enableSelection();
                _enableTour();
                Workspace.init();
            } else {
                _enableSidebar(false);
                _enableLogin(false);
            }
        });

    return {
        doLogin
    };
})();

window.NeoGIG = {
    Api: api,
    Controls: LayerControls,
    Environment: environment,
    InfoBoard: infoBoard,
    Layers: layers,
    Map: map,
    Sidebar: sidebar,
    Info: LayerInfo
};

export default bootstrap;



// WEBPACK FOOTER //
// ./src/scripts/bootstrap.js